import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import App from './App';
import './index.css';
import './App.css';
import QRCode from './components/Administration/QRCode';
import Users from './components/Administration/Users';
import SignIn from './components/Security/SignIn';
import Logs from './components/Administration/Logs';
import Dashboard from './components/Dashboard';
import Customers from './components/Administration/Customers';
import UserAccount from './components/User/Account';
import Settings from './components/Settings/Settings';
import Whisper from './components/Administration/Whisper';
import Location from './components/Administration/Location';
import UpdatePassword from './components/Security/UpdatePassword';
import { ToastContainer } from 'react-toastify';
import WhisperIndex from './components/Whisper/WhisperIndex';
import ErrorBoundary from './components/Common/ErrorBoundary';
import PerformanceReviewComponent from './components/User/PerformanceReview';
import MonthlyInterest from './components/Whisper/MonthlyInterest';
import MyAccount from './components/Administration/MyAccount';
import NoAccess from './components/NoAccess/NoAccess';
import PageNotFound from './components/NoAccess/PageNotFound';
import SalesRepAssignment from './components/Administration/SalesRepAssignment';
import MFA from './components/Security/MFA';
import ItemsPurchased from './components/Administration/Customer/ItemsPurchased';
import ProductModel from './components/Administration/ProductModel';
import Help from './components/Security/Help';

const user = JSON.parse(localStorage.getItem('user') || '{}');
const interests = JSON.parse((document.getElementById('interests') as HTMLInputElement)?.value || '[]');
const top_opportunities = JSON.parse((document.getElementById('top_opportunities') as HTMLInputElement)?.value || '[]');


const router = createBrowserRouter([
  {
    Component: App, // root layout route
    children: [
      {
        path: user === '{}' ? '/login' : user.is_pass_changed == 0 ? '/update-password' : '/',
        element: user === '{}' ? <SignIn /> : (user.is_pass_changed == 0 ? <UpdatePassword /> : <Dashboard user={user} />),
        children: user.is_pass_changed == 1 ? [
          {
            path: '*',
            element: <PageNotFound />,
          },
          {
            path: '/no-access',
            element: <NoAccess />,
          },
          {
            path: '/admin/users',
            element: <Users loggedInUser={user} />,
          },
          {
            path: '/qrcode',
            element: <QRCode />,
          },
          {
            path: '/admin/logs',
            element: <Logs />,
          },
          {
            path: '/customers/:id',
            element:  <Customers />,
          },
          {
            path: '/users/:id/account',
            element: <UserAccount />,
          },
          {
            path: '/admin/settings',
            element: <Settings />,
          },
          {
            path: '/admin/whispers/wizard',
            element: <Whisper />,
          },
          {
            path: '/admin/locations',
            element: <Location />,
          },
          // {
          //   path: '/admin/permissions',
          //   element: <Permission />,
          // },
          {
            path: user.role === 'Administrator' ? '/admin/whispers' : user.role === 'Executive' ? '/executive/whispers' : '/whispers',
            element: <WhisperIndex />,
          },
          {
            path: user.role === 'Administrator' ? '/admin/whisper/monthly-interests' : user.role === 'Executive' ? '/executive/whisper/monthly-interests' : '/whisper/monthly-interests',
            element: <MonthlyInterest perm={user.role === 'Administrator' ? 'admin' : user.role === 'Executive' ? 'executive' : ''} />,
          },
          {
            path: user.role === 'Administrator' ? '/admin/my-accounts' : user.role === 'Executive' ? '/executive/my-accounts' : '/my-accounts',
            element: <MyAccount />,
          },
          {
            path: user.role === 'Administrator' ? '/admin/performance-review' : user.role === 'Executive' ? '/executive/performance-review' : '/performance-review',
            element: <PerformanceReviewComponent height={600} />,
          },
          {
            path: user.role === 'Administrator' ? '/admin/customers/:id/items-purchased' : user.role === 'Executive' ? '/executive/customers/:id/items-purchased' : '/customers/:id/items-purchased',
            element: <ItemsPurchased />,
          },
          {
            path: user.role === 'Administrator' ? '/admin/product-model' : user.role === 'Executive' ? '/executive/product-model' : '/product-model',
            element: <ProductModel />,
          },
          // {
          //   path: '/admin/users/assignments',
          //   element: <SalesRepAssignment />,
          // },
          {
            path: '/mfa',
            element: <MFA />,
          },
          {
            path: '/help',
            element: <Help />,
          },
        ] : undefined,
      },
    ],
  },
]);

const loginDiv = document.getElementById('login');
const updatePasswordDiv = document.getElementById('update-password');
const pageNotFoundDiv = document.getElementById('page_not_found');
const mfaDiv = document.getElementById('mfa');
const helpDiv = document.getElementById('help');
if (loginDiv) {
  ReactDOM.createRoot(loginDiv).render(
    <React.StrictMode>
      <ToastContainer />
      <SignIn />
    </React.StrictMode>
  );
} else if (mfaDiv) {
  ReactDOM.createRoot(mfaDiv).render(
    <React.StrictMode>
      <ToastContainer />
      <MFA />
    </React.StrictMode>
  );
}
else if (updatePasswordDiv) {
  ReactDOM.createRoot(updatePasswordDiv).render(
    <React.StrictMode>
      <ToastContainer />
      <UpdatePassword />
    </React.StrictMode>
  );
}else if (pageNotFoundDiv) {
  ReactDOM.createRoot(pageNotFoundDiv).render(
    <React.StrictMode>
      <ToastContainer />
      <PageNotFound />
    </React.StrictMode>
  );
}
else if (helpDiv) {
  ReactDOM.createRoot(helpDiv).render(
    <React.StrictMode>
      <Help />
    </React.StrictMode>
  );
}
else{
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary fallback={<div>Error loading app</div>}>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
